import { $nin as __nin, createExpressionOperator } from "../../_predicates";
const $nin = createExpressionOperator(__nin);
export {
  $nin
};
